// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ChRMX","spin":"Loader_spin__Soegw","loader_container":"Loader_loader_container__96DWM"};